module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_waso-5f72fe55292600ea6f20ab888956cd4f.jpg";